import { useState } from 'react';
import './JobsBoardHeroSection.css';

const roleFilters = [
  'All roles',
  'AI Engineer',
  'Architect',
  'Data',
  'Cloud',
  'Copilot / Power Platform'
];

function JobsBoardHeroSection() {
  const [activeFilter, setActiveFilter] = useState('Copilot / Power Platform');

  return (
    <section className="jobs-board-hero" aria-labelledby="jobs-board-hero-title">
      <div className="jobs-board-hero__content">
        <p className="jobs-board-hero__eyebrow">THE LWT JOBS BOARD</p>

        <h1 id="jobs-board-hero-title" className="jobs-board-hero__title">
          Find your next role.
          <br />
          <span>Know exactly how to get there.</span>
        </h1>

        <p className="jobs-board-hero__subtitle">
          Browse curated tech roles and real open jobs. For each one, see the exact skills it
          requires versus what you already have. Find your gap, then close it.
        </p>

        <div className="jobs-board-hero__filters" role="list" aria-label="Role filters">
          {roleFilters.map((filter) => (
            <button
              key={filter}
              type="button"
              role="listitem"
              className={`jobs-board-hero__filter ${activeFilter === filter ? 'is-active' : ''}`}
              onClick={() => setActiveFilter(filter)}
            >
              {filter}
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}

export default JobsBoardHeroSection;
